import React from "react";
import type ContentDashboardDto from "../../types/dtos/content-dashboard/ContentDashboardDto";
import ContentDashboardGroup from "./ContentDashboardGroup";
import { isEmployeeContentWidgetVisible } from "../../helpers/contentDashboardWidgets";

interface ContentDashboardProps {
  dashboardData: ContentDashboardDto | null;
  isLoading: boolean;
}

const ContentDashboard: React.FC<ContentDashboardProps> = ({
  dashboardData,
  isLoading,
}) => {
  // Don't show anything while loading - parent handles loading state
  if (isLoading || !dashboardData) {
    return null;
  }

  // Filter groups to only those with visible widgets
  const groupsWithContent = dashboardData.groups.filter((group) => {
    const visibleWidgets = group.widgets.filter((widget) =>
      isEmployeeContentWidgetVisible(widget)
    );
    return visibleWidgets.length > 0;
  });

  // If no groups have content, don't show anything
  if (groupsWithContent.length === 0) {
    return null;
  }

  return (
    <div className="space-y-8">
      {groupsWithContent.map((group, index) => (
        <ContentDashboardGroup
          key={group.id}
          group={group}
          showDivider={index < groupsWithContent.length - 1}
        />
      ))}
    </div>
  );
};

export default ContentDashboard;
